<template>
    <v-autocomplete
      label="Profile"
      v-model="localFilter.SelectedPositionTypes"
      clear-on-select
      prepend-inner-icon="mdi-account-question"
      chips
      clearable
      closable-chips
      :items="refstore.PositionTypes"
      auto-select-first="exact"
      item-title="label"
      item-value="id"
      ref="autocomplete0"
      @update:modelValue="closeDropdown"
      multiple
    />
</template>

<script>
import { ReferentialStore } from '@/stores'
import { LynxUtils } from '@/utils'

export default {
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  computed: {
    localFilter: {
      get () {
        return this.filter
      }
      /*
      ,
      set (value) {
        this.$emit('update:filter', value)
      }
      */
    },
    refstore: function () {
      return ReferentialStore()
    },
    utils: function () {
      return LynxUtils
    }
  },
  methods: {
    closeDropdown () {
      // Accède à la référence de v-autocomplete et déclenche la méthode blur pour fermer le menu
      this.$refs.autocomplete0.blur()
    }
  }
}
</script>
